import { FC } from 'react';
import DeliveryConditions from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/containers/DeliveryConditions/DeliveryConditions';
import BranchZonesTable from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/containers/BranchZonesTable/BranchZonesTable';

const BranchDeliverySettings: FC = (): JSX.Element => {
  return (
    <div className="d-flex flex-row flex-1">
      <DeliveryConditions />
      <BranchZonesTable />
    </div>
  );
};

export default BranchDeliverySettings;
